module.exports = __webpack_public_path__ + "static/media/snapscope-2.6fa6dfff.jpg";